<route lang="yaml">
meta:
  title: 主页
  icon: ant-design:home-twotone
</route>

<script setup lang="ts">
import type { dashboardCardBinListType, dashboardCardStatusType, dashboardInfoAccountType } from '@/api/modules/index'
import apiIndex from '@/api/modules/index'
import AccountBalance from '@/views/index/components/AccountBalance/index.vue'
import CardCount from '@/views/index/components/CardCount/index.vue'
import FundTrends from '@/views/index/components/FundTrends/index.vue'
import LastRecharge from '@/views/index/components/LastRecharge/index.vue'

import { toast } from 'vue-sonner'

const loading = ref(true)
const account = ref<dashboardInfoAccountType>({
  balance: '0',
  recharge_sum: '0',
  recharge_count: 0,
  recharge_pending_sum: '0',
  recharge_pending_count: 0,
})
const cardBinList = ref<Array<dashboardCardBinListType>>([])
const cardCount = ref(0)
const cardStatus = ref<dashboardCardStatusType>({
  normal: 0,
  canceling: 0,
  cancelled: 0,
  other: 0,
})
function getData() {
  loading.value = true
  apiIndex.info().then((res) => {
    if (res.status === 0) {
      account.value = res.data.account
      cardCount.value = res.data.card.card_count
      cardBinList.value = res.data.card.cardbin_list
      cardStatus.value = res.data.card.card_status
    }
    else {
      toast.error(res.msg)
    }
  }).finally(() => {
    loading.value = false
  })
}
onMounted(() => {
  getData()
})
</script>

<template>
  <div class="px-6 pt-6">
    <el-row :gutter="20">
      <el-col :xl="7" :lg="7" :md="24" :sm="24" :xs="24">
        <AccountBalance :account :loading />
      </el-col>
      <el-col :xl="17" :lg="17" :md="24" :sm="24" :xs="24">
        <CardCount :card-bin-list="cardBinList" :card-count="cardCount" :card-status="cardStatus" :loading />
      </el-col>
      <el-col :xl="17" :lg="17" :md="24" :sm="24" :xs="24">
        <LastRecharge />
      </el-col>
      <el-col :xl="7" :lg="7" :md="24" :sm="24" :xs="24">
        <FundTrends />
      </el-col>
    </el-row>
  </div>
</template>
